




































/* 
  getReceiveInfo 通知消息
*/
import { Vue, Component } from "vue-property-decorator";
import { getReceiveInfo } from "../../../api/teacherRole";

@Component({
  name: "employInfo"
})
export default class extends Vue {
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = [{ propXXX: "XXX" }]; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 10; //当前条目
  private total: number = 0; //总条数

  created() {
    //获取列表
    this.getData();
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    let params = {
      current: this.pageNo,
      size: this.pageSize
    };
    try {
      let res = await getReceiveInfo(params);
      this.showTableLoading = false;
      this.tableData = res.data.records;
      this.total = res.data.total;
      // this.pageNo = res.data.current;
      // this.pageSize = res.data.size;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error.mesg || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  // 根据分页计算页码
  private indexMethod(index) {
    return index + 1 + (this.pageNo - 1) * this.pageSize;
  }

  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }
  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }
}
